import { FieldNames } from 'Constants/FieldNames'

export enum BgAgreementType {
	CONFIRMATION = 'confirmation',
	PAPER_LEAD = 'paper_lead',
	ELECTRONIC = 'electronic',
}

export const BgAgreementTranslate = {
	[BgAgreementType.CONFIRMATION]: 'СМС',
	[BgAgreementType.PAPER_LEAD]: 'Документ',
	[BgAgreementType.ELECTRONIC]: 'В электронном виде',
}

export enum BgAgreementFaceType {
	LEADER = 'leader',
	CONFIDANT = 'confidant',
}

export const SECOND_LIMIT_CONFIRM = 180

export const BgAgreementBtnTranslate = {
	[BgAgreementType.CONFIRMATION]: 'send_link',
	[BgAgreementType.PAPER_LEAD]: 'send_agreement',
	[BgAgreementType.ELECTRONIC]: 'continue',
}

export enum RequestType {
	REQUEST = 'request ',
	LIMIT_REQUEST = 'limit_request',
}

export const fieldsToReset = [
	FieldNames.AUTHPERSONCITIZENSHIP,
	FieldNames.AUTHPERSONPLACE,
	FieldNames.AUTHPERSONDATE,
	FieldNames.AUTHPASSPORT,
	FieldNames.AUTHPASSPORTSER,
	FieldNames.AUTHPASSPORTNUM,
	FieldNames.AUTHPASSPORTDATEGIVE,
	FieldNames.AUTHPASSPORTWHOGIVE,
	FieldNames.AUTHPASSPORTKOD,
	FieldNames.AUTHADDRESS,
	FieldNames.AUTHINN,
	FieldNames.AUTHPOSITION,
]

export const enum AgreementCheckboxFieldNames {
	ELECTRONIC = 'is_electronic_agreement',
}

export const AgreementCheckboxFields = [AgreementCheckboxFieldNames.ELECTRONIC] as string[]
